import type { ComponentProps, ReactNode } from "react";
import { Icon } from "components/icon/Icon";
import { Text } from "components/text";

export const EmptyChart = ({
  title,
  text,
  ...props
}: ComponentProps<"div"> & {
  title: string;
  text: ReactNode;
}) => (
  <div
    {...props}
    className="flex flex-col items-center gap-3 rounded-lg border border-dashed border-border bg-secondary-25 px-8 py-12 text-center"
  >
    <span className="inline-flex h-11 w-11 items-center justify-center rounded-full bg-caution-100">
      <Icon name="info" iconClassName="text-caution-700" />
    </span>
    <Text variant="bodyStrong">{title}</Text>
    <Text variant="muted" className="max-w-200">
      {text}
    </Text>
  </div>
);
